import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

function getPropValueFromSize(size, sizeList) {
  let propValue

  if (size in sizeList) {
    propValue = sizeList[size]
  } else {
    propValue = sizeList.md
  }

  return propValue
}

function getPaddingFromSize(size) {
  let PADDING_DEFAULT = {
    sm: '8px 16px',
    md: '12px 16px',
    lg: '24px 16px',
  }

  return getPropValueFromSize(size, PADDING_DEFAULT)
}

const Button = styled.button`
  border: 1px solid ${getToken('color-neutral')};
  display: block;
  font-family: ${getToken('font-family-default')};
  font-size: 14px;
  text-align: center;
  user-select: none;

  background-color: ${props => (props.activated ? getToken('color-primary') : 'transparent')};
  border-color: ${props =>
    props.activated ? getToken('color-primary') : getToken('color-neutral-dark')};
  color: ${props =>
    props.activated
      ? getToken('color-neutral-lightest')
      : props.color || getToken('color-neutral-darker')};
  font-weight: ${props => (props.activated || props.bold ? '600' : 500)};
  width: ${props => (props.width ? props.width : 'auto')};
  padding: ${({ size }) => getPaddingFromSize(size)};
  border-radius: ${getToken('border-radius-s')};
  text-transform: ${({ upperCase }) => (upperCase ? 'uppercase' : 'none')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};
`

const Link = Button.withComponent('a')

export function ButtonAction(props) {
  const { className } = props

  let component = (
    <Button {...props} className={className}>
      {props.children}
    </Button>
  )

  if (props.href) {
    component = (
      <Link {...props} className={className}>
        {props.children}
      </Link>
    )
  }

  return component
}
